import React from 'react';
import { useQuery } from '@apollo/client';
import { QueryListResponse } from 'global';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { bpfAPI, BPFAPINameSpase, Department, DepartmentsManager } from 'modules/stages';

export const Departments = () => {
  const { data, loading, error } = useQuery<BPFAPINameSpase<QueryListResponse<Department>>>(
    bpfAPI.department.fetchDepartments
  );

  const listOfDepartments = data?.bpf?.result?.list ?? [];

  return (
    <PageContainer title="BPF Departments" error={error} loading={loading}>
      <DepartmentsManager list={listOfDepartments} />
    </PageContainer>
  );
};
